<template>
    <div>
        <action-bar>
            <!--
            <router-link :to="{name: 'user-create'}" class="btn btn-primary">Benutzer erstellen</router-link>
            -->
        </action-bar>
        <main class="content">
            <h1>Benutzer</h1>
            <table class="table table-striped" v-if="users">
                <thead>
                <tr>
                    <th>Benutzername</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="user in users" v-if="users.length">
                    <td>{{user.email}}</td>
                    <td>
                        <i class="fa fa-trash fa-fw"></i>
                        <router-link :to="{name: 'user-edit', params: {userId: user.id}}"><i class="fa fa-edit fa-fw"></i>
                        </router-link>
                    </td>
                </tr>
                <tr v-else>Keine Benutzer vorhanden</tr>
                </tbody>
            </table>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
export default {
  asyncComputed: {
    users() {
      return axios
        .get("/api/" + store.state.language + "/user/list")
        .then(({ data }) => {
          return data.result;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/user/List.vue